import CarouselDisplayTrigger from '@alltrails/analytics/enums/CarouselDisplayTrigger';
import { ReactNode, useState } from 'react';
import UpsellTrigger from '@alltrails/analytics/enums/UpsellTrigger';
import Typography from '@alltrails/shared/denali/components/Typography';
import useUser from 'hooks/useUser';
import PurchaseTier from 'types/PurchaseTier';
import ProductsAvailable from '@alltrails/analytics/enums/ProductsAvailable';
import BaseUpsellModal from '../UpsellSystem/BaseUpsell/BaseUpsellModal';
import PlanSelection from '../PlanSelection/PlanSelection';
import PeakFeatureList from '../UpsellSystem/PeakFeatureList/PeakFeatureList';
import getCtaText from '../UpsellSystem/getCtaText';

type Props = {
  heading: ReactNode;
  isOpen: boolean;
  onCloseRequest: () => void;
  promoEligibleHeading: ReactNode;
  returnTo?: string;
  upsellTrigger: UpsellTrigger;
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=5543-297520&t=9h0uykTwgb7vGafI-0
export default function PlusPreviewUpsell({ heading, promoEligibleHeading, onCloseRequest, isOpen, upsellTrigger, returnTo }: Props) {
  const user = useUser();
  const isPromoEligible = user?.isPromoEligible;
  const [tierSelected, setTierSelected] = useState<PurchaseTier>('plus');

  return (
    <BaseUpsellModal
      primaryButtonText={getCtaText(tierSelected, isPromoEligible)}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      returnTo={returnTo}
      upsellTrigger={upsellTrigger}
      tierSelected={tierSelected}
      productsAvailable={ProductsAvailable.PlusPeak}
    >
      <>
        <Typography variant="heading400">{isPromoEligible ? promoEligibleHeading : heading}</Typography>
        <PlanSelection tierSelected={tierSelected} setTierSelected={setTierSelected} showPlusFirst />
        <PeakFeatureList tierSelected={tierSelected} upsellTrigger={upsellTrigger} />
      </>
    </BaseUpsellModal>
  );
}
